import * as i18n from "i18next";
import resourcesToBackend from "i18next-resources-to-backend";
import { initReactI18next } from "react-i18next";

import type { InitOptions } from "i18next";

const i18nNameSpace = "translation";

// *i18n: 언어 추가 시 작성 필요
export const fallbackLng = "en";
export const languageLabels = [
  [fallbackLng, "English"],
  ["ko", "한국어"],
  ["ja", "日本語"],
  // ["zh", "中文(准备中)"],
  // ["es", "Español"],
  // ["fr", "Français"],
  // ["it", "Italiano"],
];
const languages = ["ko", fallbackLng, "ja" /* "ja", "zh", "es",  "fr", "it" */];

const localLang = localStorage.getItem("my-becon-fe-lib-i18n");
const browserLang = navigator.language;

function getOptions(lng: string = fallbackLng): InitOptions {
  return {
    lng,
    fallbackLng,
    supportedLngs: languages,
    ns: [i18nNameSpace, "becon-fe-lib"],
    defaultNS: i18nNameSpace,
    fallbackNS: i18nNameSpace,
    debug: false,
    keySeparator: false,
    returnNull: false,
    returnEmptyString: false,
    nsSeparator: "=>",
    interpolation: {
      escapeValue: true,
      alwaysFormat: false,
    },
    react: {
      defaultTransParent: "div",
      transEmptyNodeValue: "",
      transSupportBasicHtmlNodes: true,
      transWrapTextNodes: "",
    },
  };
}

i18n
  .use(initReactI18next)
  .use(
    resourcesToBackend((language: string, namespace: string) => {
      if (namespace === "becon-fe-lib") {
        return import(`../../../node_modules/@becon-team/becon-fe-lib/dist/locales/${language}/${namespace}.json`);
      }

      return import(`./locales/${language}/${namespace}.json`);
    }),
  )
  .init({
    ...getOptions(localLang || browserLang),
  });

export default i18n;
